import './styles.scss';

import React, { useEffect, useState } from 'react';
import { Flex, Loader } from '@gjensidige/builders-components';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';

import tracker from './tracking';
import { InputWidgetContainer } from './containers/InputWidgetContainer';
import { AppHelper } from './utils/AppHelper';

export const App: React.FC = () => {
  const [isReady, setIsReady] = useState(false);
  let imageLocations = {
    image: '',
    smallScreenImage: ''
  };
  const IMAGE_FILE_NAME = 'MomPlayingBubbles';
  const IMAGE_FILE_NAME_SMALL_SCREEN = 'MomPlayingBubblesSmallScreen';
  const [imageUrls, setImageUrls] = useState(imageLocations);

  useEffect(() => {
    const getInitialdata = async () => {
      await AppHelper.fetchInitialData();
      if (AppHelper.AppIllustrations.length) {
        const carImageURL = await AppHelper.fetchImageUrl(
          IMAGE_FILE_NAME,
          IllustrationType.SIMPLE
        );
        const carImageSmallScreenUrl = await AppHelper.fetchImageUrl(
          IMAGE_FILE_NAME_SMALL_SCREEN,
          IllustrationType.SIMPLE
        );

        imageLocations = {
          image: carImageURL || '',
          smallScreenImage: carImageSmallScreenUrl || ''
        };
        setImageUrls(imageLocations);
        setIsReady(true);
      }
    };
    getInitialdata();
    trackPartsView();
  }, []);

  const trackPartsView = () => {
    tracker.trackEvent({
      eventLabel: 'webshop_health_widget',
      eventAction: 'impression',
      eventCategory: 'impression',
      eventModule: 'webshop'
    });
  };

  return (
    <div className="app-container">
      <Flex justify="center">
        {isReady ? (
          <InputWidgetContainer imageUrls={imageUrls} />
        ) : (
          <Loader size="lg" variant="spinner" />
        )}
      </Flex>
    </div>
  );
};
